
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs4'; // If you're using Bootstrap 4
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { async, map, startWith } from 'rxjs';
import { CourseTrackService } from '../course-track.service';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { CoursedialogComponent } from '../coursedialog/coursedialog.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-course-track',
  templateUrl: './course-track.component.html',
  styleUrls: ['./course-track.component.scss']
})
export class CourseTrackComponent {
  isInputDisabled = false;
  response: any;
  myGroup!: FormGroup;
  table: any;
  data: any;
  dialogRef: any; 
  data1: any;
 

  constructor(private course: CourseTrackService, private fb: FormBuilder, private renderer: Renderer2, public dialog: MatDialog,private dialog1: NgDialogAnimationService,private spinner: NgxSpinnerService) { }
  filterBy: string = 'PENDING';
  
  ngOnInit(): void {
    // Call the getdata method here
    this.getdata(this.filterBy);
  }
 
  getdata(filterBy: any) {
 this.spinner.show()
    this.course.gettable(filterBy).subscribe((res: any) => {
      this.table = res
      this.spinner.hide()
      $(document).ready(() => {
        $('#example').DataTable({
          scrollX: true ,
          ordering: true,
              order: [] 
        });
      });
    })
    
  }
  edit(report: any) {
    this.data = report
    this.dialogRef= this.dialog1.open(CoursedialogComponent, {
      width: "510px",
      height: "100%",
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      data: this.data

    });
    this.dialogRef.afterClosed().subscribe((value:any) => {
      console.log(value);
      if(value=="save"){
        $('#example').DataTable().destroy();
           this.getdata(this.filterBy);
           }
    })
  }
  openDialog(report: any): void {
    this.data = report

    this.dialogRef = this.dialog1.open(DialogComponent, {
      width: "510px",
      height: "100%",
      position: { right: '0' },
      maxWidth: '100%',
      animation: { to: 'left' },
      autoFocus: false,
      disableClose: true,
      data: this.data

    });

    this.dialogRef.afterClosed().subscribe((value:any) => {
     
      if(value == 'REJECTED'){
       this.pending(value)  
     }
     else if(value == 'APPROVED'){
       this.pending(value)
     }else if(value== "pending"){

       $('#example').DataTable().destroy();
       this.getdata(this.filterBy);
     }
   })
  }
  
  pending(filterParams:any) {
    this.spinner.show()
    this.course.gettable(filterParams).subscribe((res: any) => {
        this.table = res;
        this.spinner.hide()
        $('#example').DataTable().destroy();
        $(document).ready(() => {
          $('#example').DataTable({
            scrollX: true,

            ordering: true,
              order: [] 
          });
        });    
    });
  }

onOptionSelected(){
  this.isInputDisabled = true;
}
opendialog1(){
  this.dialogRef = this.dialog1.open(CoursedialogComponent, {
    width: "510px",
    height: "100%",
    position: { right: '0' },
    maxWidth: '100%',
    animation: { to: 'left' },
    autoFocus: false,
    disableClose: true,
    // hasBackdrop: false,
    data: this.data1,
  });
  this.dialogRef.afterClosed().subscribe((value:any) => {
    console.log(value);
    if(value=="save"){
      $('#example').DataTable().destroy();
         this.getdata(this.filterBy);
         }
  })
}
}
